import { render } from "./motion-setup.vue?vue&type=template&id=384b4831&scoped=true"
import script from "./motion-setup.vue?vue&type=script&lang=js"
export * from "./motion-setup.vue?vue&type=script&lang=js"

import "./motion-setup.vue?vue&type=style&index=0&id=384b4831&scoped=true&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384b4831"]])

export default __exports__